"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fileService_1 = require("./fileService");
var windowService_1 = require("./windowService");
var toFile = function (file, canvas, _a) {
    var preserveFileType = _a.preserveFileType, quality = _a.quality;
    var type = preserveFileType ? file.type : 'image/jpeg';
    var dataUrl = canvas.toDataURL(type, quality);
    var base64 = dataUrl.split(',')[1];
    var uint8ArrayOfArrays = windowService_1.default.toByteArray(base64);
    return fileService_1.default.create(uint8ArrayOfArrays, type, file.name);
};
exports.default = {
    toFile: toFile,
};
